export const colors = {
  primary: "#2E7D32", // Main green
  secondary: "#EEF5EE", // Accent green
  background: "#F5F5F5",
  surface: "#FFFFFF",
  text: "#1A1A1A",
  textSecondary: "#9E9E9E",
  error: "#FF3B30",
  success: "#34C759",
  warning: "#FFCC00",
  border: "#757575",
  white: "#FFFFFF",
  black: "#1A1A1A",
  darkGreen: "#1B5E20",
  lightGreen: "#A5D6A7",
  gray: "#9E9E9E",
  darkGray: "#424242",
  lightGray: "#616161",
  orange: "#F57C00",
  textGray: "#666666",
  textGrayLight: "#999999",
  // Gradient colors for react-native-linear-gradient
  inputBorderColor: "#E0E0E0",
};

export type Colors = typeof colors;
